<div class="standard-max-width">
    <div class="flex align-items-center justify-content-between mt-2 mb-6">
        <div class="flex align-items-center">
            <i class="pi pi-user text-2xl mr-2"></i>
            <span class="text-2xl font-semibold">{{ 'PROFILE' | translate }}</span>
        </div>
        <button *ngIf="mode === 'read'" pButton type="button" icon="pi pi-pencil" label="{{ 'EDIT' | translate }}"
            class="p-button-text" (click)="enableEditMode()"></button>
    </div>
    <ng-container *ngIf="me; else loading">
        <app-crud-user [mode]="mode" [roleContext]="'me'" (updateSuccess)="onUpdateSuccess()"
            (cancelPressed)="onCancel()">
            <!-- Pass necessary inputs and handle outputs -->
        </app-crud-user>

        <!-- Horizontal Line -->
        <div class="col-12">
            <hr class="my-3"> <!-- Added horizontal line -->
        </div>
        <i class="pi pi-globe mr-2"></i> <!-- Added icon -->
        Preferred Language

        <app-global-lang-chooser [showGlobeIcon]="false"></app-global-lang-chooser>

        <!-- Horizontal Line -->
        <div class="col-12">
            <hr class="my-3">
        </div>

        <div class="flex align-items-center justify-content-between mb-6">
            <div class="flex align-items-center">
                <i class="pi pi-exclamation-triangle text-xl mr-2 text-red-500"></i>
                <span class="text-xl font-semibold text-red-500">Delete Account</span>
            </div>

            <p-button label="Delete" severity="danger" [outlined]="true" icon="pi pi-trash"
                (onClick)="deleteUser($event)">
            </p-button>
        </div>

        <!-- Horizontal Line -->
        <div class="col-12">
            <hr class="my-3">
        </div>

        <div class="mb-6">
            <div class="font-bold mb-2">Your GDPR Rights</div>
            <p class="mb-3">For all enquiries about exercising your GDPR rights, please contact us
                at mark.nattriss&#64;wolffsohnresearch.com</p>

            <ul class="pl-4 m-0 line-height-3">
                <li>The right to be informed</li>
                <li>The right of access</li>
                <li>The right to rectification</li>
                <li>The right to erasure</li>
                <li>The right to restrict processing</li>
                <li>The right to data portability</li>
                <li>The right to object</li>
                <li>Rights in relation to automated decision making and profiling.</li>
            </ul>
        </div>

        <!-- Horizontal Line -->
        <div class="col-12">
            <hr class="my-3">
        </div>

        <div class="mb-6">
            <div class="font-bold mb-2">Legal Documents</div>
            <div class="flex flex-column gap-2">
                <a href="https://www.wolffsohnresearch.com/premo-terms-and-conditions" target="_blank"
                    class="text-primary no-underline hover:underline">Terms and Conditions</a>
                <a href="https://www.wolffsohnresearch.com/premo-privacy-policy" target="_blank"
                    class="text-primary no-underline hover:underline">Privacy Policy</a>
                <a href="https://www.wolffsohnresearch.com/premodataprocessingagreement" target="_blank"
                    class="text-primary no-underline hover:underline">Data Processing Agreement</a>
            </div>
        </div>

        <!-- Horizontal Line -->
        <div class="col-12">
            <hr class="my-3">
        </div>

        <div class="flex flex-column gap-1 mb-6">

            <div class="font-bold">PreMO Data Controller & Quality Manager</div>
            <div>Mark Nattriss</div>
            <div><a href="mailto:mark.nattriss@wolffsohnresearch.com"
                    class="text-primary no-underline hover:underline">mark.nattriss&#64;wolffsohnresearch.com</a></div>

            <div class="mt-3">Wolffsohn Research Ltd</div>
            <div>16 Limetree Court</div>
            <div>Lisburn</div>
            <div>Northern Ireland</div>
            <div>BT28 2WG</div>
            <div>United Kingdom</div>

            <p class="mb-3">For all enquiries about GDPR export, deleting and amending organisations please contact us
                at mark.nattriss&#64;wolffsohnresearch.com</p>

        </div>

        <p-confirmDialog [style]="{maxWidth: '600px'}" [appendTo]="'body'"></p-confirmDialog>
    </ng-container>

    <ng-template #loading>
        <p>{{ 'LOADING_PROFILE' | translate }}</p>
        <!-- Optional: Add a spinner -->
        <!-- <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner> -->
    </ng-template>
</div>